import React, { useRef, useState } from "react";
import { Box, Flex, Image, SimpleGrid, Spinner, Text } from "@chakra-ui/react";
import { FaImages, FaTimes } from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM, TRANSITION } from "../Theme/styles";

const ImagePicker = ({ images, onChange }) => {
  const [uploading, setWgrywam] = useState(false);
  const [dragOver, setNadPolem] = useState(false);
  const [error, setBlad] = useState(null);
  const fileInput = useRef(null);

  const upload = async (listaPlikow) => {
    const pictures = Array.from(listaPlikow).filter((p) =>
      p.type.startsWith("image/")
    );
    if (pictures.length === 0) return;

    setWgrywam(true);
    setBlad(null);
    try {
      const urls = [];
      for (const file of pictures) {
        const base64 = await new Promise((ok, no) => {
          const reader = new FileReader();
          reader.onload = () => ok(String(reader.result).split(",")[1]);
          reader.onerror = no;
          reader.readAsDataURL(file);
        });
        const odp = await axios.post(
          `${API_URL}/upload`,
          { image: base64 },
          {
            withCredentials: true,
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );
        if (odp.data?.url) urls.push(odp.data.url);
      }
      onChange([...images, ...urls]);
    } catch (e) {
      setBlad("Nie udało się wgrać zdjęcia.");
    } finally {
      setWgrywam(false);
    }
  };

  return (
    <Box>
      <Box
        onClick={() => fileInput.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setNadPolem(true);
        }}
        onDragLeave={() => setNadPolem(false)}
        onDrop={(e) => {
          e.preventDefault();
          setNadPolem(false);
          upload(e.dataTransfer.files);
        }}
        onPaste={(e) => upload(e.clipboardData.files)}
        tabIndex={0}
        cursor="pointer"
        borderRadius="md"
        border="1px dashed"
        borderColor={dragOver ? "#6C99FF" : FORUM.obramowanie}
        bg={dragOver ? "rgba(108,153,255,0.06)" : FORUM.tlo}
        transition={TRANSITION}
        px={4}
        py={5}
        _hover={{ borderColor: "rgba(255,255,255,0.18)" }}
      >
        <Flex direction="column" align="center" gap={1}>
          {uploading ? (
            <Spinner size="sm" color={FORUM.tekstPrzygaszony} />
          ) : (
            <FaImages color={FORUM.tekstPrzygaszony} size={18} />
          )}
          <Text fontSize="sm" color={FORUM.tekst}>
            {uploading ? "Wgrywam…" : "Przeciągnij zdjęcia, wklej (Ctrl+V) albo kliknij"}
          </Text>
          <Text fontSize="xs" color={FORUM.tekstPrzygaszony}>
            Można dodać kilka naraz
          </Text>
        </Flex>

        <input
          ref={fileInput}
          type="file"
          accept="image/*"
          multiple
          hidden
          onChange={(e) => {
            upload(e.target.files);
            e.target.value = "";
          }}
        />
      </Box>

      {error && (
        <Text fontSize="xs" color="#F08A80" mt={2}>
          {error}
        </Text>
      )}

      {images.length > 0 && (
        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={2} mt={3}>
          {images.map((url) => (
            <Box key={url} position="relative" borderRadius="md" overflow="hidden">
              <Image
                src={url}
                alt="Załącznik"
                w="100%"
                h="80px"
                objectFit="cover"
              />
              <Flex
                position="absolute"
                top={1}
                right={1}
                w="20px"
                h="20px"
                align="center"
                justify="center"
                borderRadius="full"
                bg="rgba(0,0,0,0.65)"
                cursor="pointer"
                transition={TRANSITION}
                _hover={{ bg: "rgba(197,48,48,0.9)" }}
                onClick={() => onChange(images.filter((a) => a !== url))}
                title="Usuń"
              >
                <FaTimes color="#fff" size={10} />
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default ImagePicker;
